import { render, staticRenderFns } from "./ManageFood.vue?vue&type=template&id=78fd9b3e&"
import script from "./ManageFood.vue?vue&type=script&lang=js&"
export * from "./ManageFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports